import DataHelper from "../../helpers/data.helper";
import { formatDateTime } from "../../helpers/dateFormat";
import InitSalariesLogic from "./Salaries.logic";

const SalariesComponent: React.FC = () => {
    const { selectedClient, clients, data, onChange, selectClient, removeSelectedClient, loadClients } = InitSalariesLogic();
    return (
        <div className="page-container">
            <h1 className="text-align-center">Plate</h1>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <button className="btn-primary" type="button" onClick={loadClients}>Učitaj</button>

                <div>
                    <label htmlFor="fromDate">Od (uključen)</label>
                    <input id="fromDate" type={"date"} value={data.fromDate} onChange={onChange} name="fromDate"></input>
                </div>

                <div>
                    <label htmlFor="toDate">Do (isključen)</label>
                    <input id="toDate" type={"date"} value={data.toDate} onChange={onChange} name="toDate"></input>
                </div>

                {clients?.length > 0 && (
                    <div>
                        <label htmlFor="client">Pretraga trenera</label>
                        <input placeholder="Traži po imenu ili prezimenu..." id="client" type={"text"} value={data.client} onChange={onChange} name="client"></input>
                    </div>
                )}
            </div>

            {selectedClient !== undefined && (
                <div className="card" style={{ marginTop: '16px' }}>
                    <button className="btn-secondary" type="button" onClick={() => removeSelectedClient(selectedClient)}>{selectedClient.firstName} {selectedClient.lastName}</button>
                </div>
            )}

            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '12px' }}>
                {clients.map((c) => c.firstName.concat(" ", c.lastName).toLowerCase().replaceAll("ć", "c").replaceAll("č", "c").replaceAll("š", "s").replaceAll("ž", "z").replaceAll("đ", "dj").includes(data.client.toLowerCase().replaceAll("ć", "c").replaceAll("č", "c").replaceAll("š", "s").replaceAll("ž", "z").replaceAll("đ", "dj")) ? (
                    <button type="button" key={c.id} onClick={() => selectClient(c)}>{c.firstName} {c.lastName}</button>
                ) : "")
                }
            </div>

            {selectedClient !== undefined && (
                <div style={{ marginTop: '16px' }}>
                    <div className="card text-align-center">
                        <h1>{selectedClient?.firstName} {selectedClient?.lastName}</h1>
                        <p>{selectedClient?.salary} dinara</p>
                    </div>

                    <div className="card" style={{ marginTop: '12px' }}>
                        <h3 className="text-align-center">Treninzi</h3>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '8px' }}>
                            {selectedClient?.trainings.map((training: any) => (
                                <div key={training.id} style={{ borderBottom: '1px solid var(--border)', paddingBottom: '8px' }}>
                                    <p>{formatDateTime(training.date)}</p>
                                    <p>{DataHelper.trainingTypesIdsTrainingTypesForUser[training.trainingType.id] ?? training.trainingType.name ?? ""}</p>
                                    <p>Klijenti:</p>
                                    {training.clients?.map((client: any) => (
                                        <p key={client.id}>{client.firstName} {client.lastName}</p>
                                    ))}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default SalariesComponent;
